import en from './en'

const reservedTranslationsWithUniqueKeyNames = {
  leadingSpaceNotAllowed: '不允许前置空格。',
  trailingSpaceNotAllowed: '不允许尾随空格。',
  mustbeAtleastCharacters: '{{label}} 至少需要 {{minNumber}} 个字符',
  cannotExceedCharacters: '{{label}} 不能超过 {{maxNumber}} 个字符',
  numberMustbeAtleast: '{{label}} 至少必须为 {{minNumber}}',
  numberCannotExceed: '{{label}} 不能超过 {{maxNumber}}',
  isRequired: '{{label}} 为必填项',
  emptySpaceNotContain: '此字段不能包含空格',
  404: '404',
  register: '注册',
  login: '登录',
  comingSoon: '即将推出',
  submit: '提交',
  email: '电子邮箱',
  termsConditions: '条款和条件',
  password: '密码',
  eighteenPlus: '我已年满 18 岁，并同意服务条款',
  signUp: '注册',
  createNewAccount: '创建新账户',
  fullName: '全名',
  referralCode: '推荐码',
  confirmPassword: '确认密码',
  facebook: 'Facebook',
  google: 'Google',
  haveAnAccount: '已有账户？',
  pageNotFound: '找不到你要访问的页面。',
  error: '错误',
  somethingWentWrong: '出了点问题。',
  personalDetails: '个人信息',
  firstName: '名字',
  lastName: '姓氏',
  dateOfBirth: '出生日期',
  phoneNumber: '电话号码',
  change: '更改',
  saveChanges: '保存更改',
  currentPassword: '当前密码',
  newPassword: '新密码',
  myProfile: '我的资料',
  transactions: '交易记录',
  deposit: '充值',
  withdraw: '提现',
  referral: '推荐',
  changePassword: '修改密码',
  logout: '退出登录',
  currency: '货币。',
  view: '查看',
  ok: '确定',
  cancel: '取消',
  userName: '用户名',
  passwordRegexMatch: '密码必须包含一个大写字母、一个数字和一个特殊字符',
  invalidEmailFormat: '邮箱格式无效',
  noRecordsFound: '未找到记录'
}

const apiSuccessMessagesTranslations = {
  loginSuccessfully: '登录成功。',
  logoutSuccessfully: '退出登录成功。',
  passwordUpdateSuccessfully: '密码更新成功。',
  updatePlayerStatusSuccessfully: '玩家状态更新成功。',
  resetPasswordSuccessfully: '密码重置成功。',
  signupSuccessfully: '注册成功。',
  betPlacedSuccessfully: '下注成功。',
  betCancelledSuccessfully: '下注取消成功。'
}

const apiErrorMessagesTranslations = {
  UnAuthorized: '你的会话已超时',
  LoginFailedError: '登录失败',
  InvalidCredentialsError: '凭据无效',
  InvalidTokenError: '令牌无效',
  InvalidSessionError: '会话已过期',
  CreateUserError: '无法创建用户',
  DataMismatchError: '数据不匹配',
  UserNotFoundError: '未找到用户',
  DuplicateEmailError: '邮箱已存在',
  RequestInputValidationError: '请检查请求数据',
  ResponseInputValidationError: '响应验证失败，请参考 JSON 模式',
  InternalServerError: '服务器内部错误',
  InvalidCredentials: '凭据不匹配',
  InvalidToken: '未提供访问令牌或令牌已过期',
  InvalidSession: '用户会话无效，请重新登录',
  InvalidAccess: '权限被拒绝',
  NonOperationalError: '服务器发生错误',
  UserNotExists: '用户不存在',
  InvalidAction: '无效操作',
  EmailNotVerified: '邮箱未验证',
  NoWalletFoundError: '未找到符合条件的钱包',
  NotEnoughBalanceError: '余额不足，无法执行该操作',
  SomethingWentWrong: '出了点问题',
  AccountNotActive: '账户未激活',
  UserAlreadyExists: '用户已存在',
  RecordNotFound: '未找到记录',
  WalletDoesNotBelongToUser: '该钱包不属于此用户'
}

const otherTranslationKeys = {
  betAmount: '下注金额',
  betHistory: '下注历史',
  provablyFair: '可验证公平',
  minimumBet: '最小下注',
  maximumBet: '最大下注',
  selectYourBetAmount: '选择你的下注金额',
  buyInAmount: '买入金额',
  selectYourBuyInAmountFromGivenRange: '从给定范围中选择买入金额',
  profitOnWin: '获胜收益',
  noOfBets: '下注次数',
  auto: '自动',
  half: '½',
  double: '2X',
  start: '开始',
  cancel: '取消',
  prediction: '预测',
  luckyNumber: '幸运数字',
  multiplier: '倍数',
  chanceToWin: '获胜概率',
  betBtn: '下注',
  bets: '下注',
  depositBtn: '充值',
  rollOver: '大于',
  rollUnder: '小于',
  invalidBetAmount: '无效的下注金额',
  maxBetAmountLimit: '已超出最大下注金额 {{value}}',
  minBetAmountLimit: '最小下注金额为 {{value}}。',
  noBalance: '下注金额大于钱包余额',
  noAutoCashout: '必须填写自动倍率。',
  autoRateLimitWarning: '自动倍率必须大于 {{value}}'
}

// NOTE: PLEASE ADD YOUR PREDICTION MARKET TRANSLATIONS HERE ONLY
const predictionMarketTranslations = {
  error: '错误',
  somethingWentWrongPleaseTryAgain: '出了点问题。请再试一次。',
  market: '市场',
  limit: '限价',
  buy: '买入',
  sell: '卖出',
  yes: '是',
  no: '否',
  up: '涨',
  down: '跌',
  yesCents: '是 {{cents}}¢',
  noCents: '否 {{cents}}¢',
  split: '拆分',
  merge: '合并',
  amount: '金额',
  shares: '份额',
  cancel: '取消',
  submit: '提交',
  refresh: '刷新',
  loading: '加载中',
  loadMore: '加载更多',
  gotIt: '知道了',
  next: '下一步',
  previous: '上一步',
  trade: '交易',
  portfolio: '投资组合',
  rules: '规则',
  volume: '成交量',
  category: '分类',
  notAvailable: '不适用',
  open: '开放',
  closed: '关闭',
  removed: '已移除',
  resolved: '已判定',
  cancelled: '已取消',
  settled: '已结算',
  ask: '卖单',
  bid: '买单',
  asks: '卖单',
  bids: '买单',
  total: '总计',
  outcome: '结果',
  options: '选项',
  history: '历史',
  positions: '持仓',
  orders: '订单',
  activity: '活动',
  comments: '评论',
  delete: '删除',
  reply: '回复',
  postComment: '发布评论',
  likeCount: '赞 ({{count}})',
  limitPrice: '限价',
  postOnly: '仅挂单',
  youPay: '你支付',
  shareCost: '份额成本',
  toWin: '可赢得',
  youWillReceive: '你将收到',
  averagePrice: '平均价格',
  payable: '应付',
  processingFee: '处理费',
  processingFees: '处理费',
  estProcessingFee: '预计处理费',
  estProcessingFeeIncluded: '预计处理费（已包含）',
  processingFeeRefundable: '处理费（可退还）',
  showMore: '显示更多...',
  feePerShareIfItFillsNow: '若现在成交，每份费用',
  marketSettled: '市场已结算',
  resultDeclared: '结果已公布',
  tradingClosedForThisOption: '该选项已停止交易。',
  waitingForNextMarket: '暂无进行中的市场。下一窗口开始后即可交易。',
  cryptoLiveNavLabel: 'Live Crypto',
  goBack: '返回',
  yourPosition: '你的持仓',
  availableToTrade: '可交易',
  locked: '锁定',
  profitLoss: '盈亏',
  yesShares: '是份额',
  noShares: '否份额',
  avgYesPrice: '是均价',
  avgNoPrice: '否均价',
  outcomeShares: '{{outcome}}份额',
  avgOutcomePrice: '{{outcome}}均价',
  payoutProfitLoss: '结算盈亏',
  outcomeWon: '{{outcome}} 获胜',
  buyOutcome: '买入 {{outcome}}',
  sellOutcome: '卖出 {{outcome}}',
  decreaseAmount: '减少金额',
  increaseAmount: '增加金额',
  decreaseShares: '减少份额',
  increaseShares: '增加份额',
  decreaseLimitPrice: '降低限价',
  increaseLimitPrice: '提高限价',
  nobodySellingRightNow: '目前没有人在卖出。试试限价单，这样你的订单可以等待成交。',
  nobodyBuyingRightNow: '目前没有人在买入。试试限价单，这样你的订单可以等待成交。',
  tooMuchMaxBuy: '数量过多。你现在最多可买入 {{amount}}$。',
  tooManySharesMaxSell: '份额过多。你现在最多可卖出 {{amount}}。',
  restAsMakerOnly: '仅作为挂单；如果会吃单则会被拒绝',
  mergeMatchedSharesIntoCollateral: '将配对的“是”和“否”份额合并回抵押金。',
  sharesPerSide: '份额（每边）',
  splitCollateralIntoShares: '将此市场的抵押金拆分为“是”和“否”份额。',
  closeTradePanel: '关闭交易面板',
  openTradePanel: '打开交易面板',
  orderSummary: '订单摘要',
  youSell: '你卖出',
  youMerge: '你合并',
  estProceedsAtMarket: '按市价预计收入',
  splitCollateral: '拆分抵押金',
  mergeShares: '合并份额',
  splitHasNoProcessingFee: '拆分不收取处理费。',
  mergeHasNoProcessingFee: '合并不收取处理费。',
  includedInWhatYouPay: '已包含在你的支付金额中。当你的订单与可用卖单撮合时适用。',
  deductedFromWhatYouReceive: '当你的订单与可用买单撮合时，将从你的收入中扣除。',
  heldWithYourOrder: '随订单一起冻结。如果订单在订单簿中等待则退还；只有立即成交时才收取。',
  onlyIfOrderFillsRightAway: '仅当你的订单立即成交时收取，并从收入中扣除；若在订单簿中等待则不收费。',
  makerFeeRebateExplanation: '如果别人吃掉你挂着的订单，你可以获得其手续费的 {{rebatePercent}}%。',
  postOnlyOrderExplanation: '仅挂单：此订单只能挂着等待。如果会立即成交，则会被取消并退还资金。',
  notEnoughMoneyInWallet: '你的钱包余额不足。',
  notEnoughYesAndNoSharesToMerge: '没有足够的“是”和“否”份额可合并。',
  notEnoughSharesToSell: '你没有那么多份额可卖。',
  maxOrderSizeIs: '最大订单规模为 {{amount}}。',
  orderCrossesOwnSellOrder: '该订单会与您在此结果上的卖单自成交。请先取消或降低该卖单。',
  orderCrossesOwnOppositeBuy: '该订单会与您对侧的买单自成交（是+否 >= 100¢）。请先取消或调整该订单。',
  orderCrossesOwnBuyOrder: '该订单会与您在此结果上的买单自成交。请先取消或提高该买单。',
  placedBuyLimitOrder: '已下买入限价单：{{shares}} 份，价格 {{price}}',
  placedSellLimitOrder: '已下卖出限价单：{{shares}} 份，价格 {{price}}',
  placedBuyMarketOrder: '已下买入市价单：金额 {{amount}}',
  placedSellMarketOrder: '已下卖出市价单：{{shares}} 份',
  mergedYesAndNoShares: '已将 {{quantity}} 份“是”和“否”份额合并为 {{amount}} 金额',
  splitAmountIntoYesAndNoShares: '已将 {{amount}} 金额拆分为 {{yesShares}} 份“是”份额和 {{noShares}} 份“否”份额',
  closedBuyLimitOrder: '已关闭买入限价单：剩余 {{remainingShares}} 份，价格 {{price}}，总计 {{shares}}',
  closedSellLimitOrder: '已关闭卖出限价单：剩余 {{remainingShares}} 份，价格 {{price}}，总计 {{shares}}',
  closedBuyMarketOrder: '已关闭买入市价单：剩余金额 {{remainingAmount}}，总计 {{amount}}',
  closedSellMarketOrder: '已关闭卖出市价单：剩余 {{remainingShares}} 份，总计 {{shares}}',
  boughtSharesFromSeller: '从 {{sellerName}} 以 {{price}} 价格买入 {{quantity}} 份',
  soldSharesToBuyer: '以 {{price}} 价格向 {{buyerName}} 卖出 {{quantity}} 份',
  marketResolvedWithOutcome: '市场已按 {{outcome}} 结果判定。结算金额：${{payout}}（{{winningShares}} 份获胜份额）。',
  buyerReceivedSharesSystemMinted: '{{buyerName}} 以 {{price}} 收到 {{quantity}} 份（系统铸造）',
  buyerBoughtSharesFromSeller: '{{buyerName}} 从 {{sellerName}} 以 {{price}} 买入 {{quantity}} 份',
  sellerSoldSharesToSystem: '{{sellerName}} 以 {{price}} 向系统卖出 {{quantity}} 份',
  sellerSoldSharesToBuyer: '{{sellerName}} 以 {{price}} 向 {{buyerName}} 卖出 {{quantity}} 份',
  notifications: '通知',
  unreadNotifications: '{{count}} 条未读通知',
  recentCount: '最近 {{count}} 条',
  loadingNotifications: '正在加载通知...',
  noNotificationsYet: '暂无通知。当订单撮合、完成或市场结算时，你会收到通知。',
  activityUpdate: '活动更新',
  marketResolved: '市场已判定',
  walletUpdated: '钱包已更新',
  justNow: '刚刚',
  pickAMarket: '选择一个市场',
  pickAMarketDescription: '打开任意市场，根据你的预测选择“是”或“否”，然后使用订单面板获取份额。',
  preferLimitOrders: '优先使用限价单',
  preferLimitOrdersDescription: '从这里开始。设置你想要的精确价格（¢）和份额数量。你的订单会留在订单簿中直到有人撮合，因此你可以控制价格。',
  noFillUseSplit: '未成交？使用拆分',
  noFillUseSplitDescription: '如果流动性不足以成交限价单，可以将抵押金拆分为等量的“是”和“否”份额，然后卖出你不想持有的一边。',
  needSpeedMarketOrders: '想要更快？使用市价单',
  needSpeedMarketOrdersDescription: '市价单会立即与当前订单簿撮合。当你想立刻获得份额并接受实时市场价格时，请使用它们。',
  holdOrCashOut: '持有或平仓',
  holdOrCashOutDescription: '你可以在判定前随时卖出，或持有到市场结算。获胜份额每份支付 $1；失败份额结算为 $0。',
  restsOnTheBookUntilMatched: '留在订单簿中直到成交',
  convertCashIntoYesAndNoShares: '将现金转换为“是 + 否”份额',
  estShares: '预计份额',
  fillsInstantlyAtBookPrices: '按订单簿价格立即成交',
  resolvedYes: '已判定 · 是',
  payoutCredited: '结算款已入账',
  closeHowItWorks: '关闭使用说明',
  tryItOut: '试试看？',
  willThereBeAUsRecessionThisYear: '今年美国会出现经济衰退吗？',
  exitTutorialAndReturnToMarkets: '退出教程并返回市场',
  exitDemo: '退出演示',
  howItWorks: '使用说明',
  demoGuide: '指南',
  demoGuideReopen: '重新打开演示指南',
  demoGuideSkip: '跳过指南',
  demoGuideFinish: '完成',
  demoGuideStepOf: '第 {{current}} 步，共 {{total}} 步',
  demoGuideBack: '返回',
  demoGuideWelcomeTitle: '欢迎来到练习场',
  demoGuideWelcomeBody: '这是一个使用虚拟资金的安全演示市场。我会指出界面的每一部分并说明用途——你可以尝试操作，也可以随时点“下一步”。',
  demoGuideWelcomeHint: '你一开始有 $1000 演示余额。这里的一切都不是真实资金。',
  demoGuideLimitTitle: '优先使用限价单',
  demoGuideLimitBody: '限价单让你设定确切价格（¢）和份额数量。它会挂在订单簿上直到有人成交——这样你可以控制价格，而不是接受当前市价。',
  demoGuideLimitHint: '我已打开“限价”，并建议以 45¢ × 10 买入“是”。想试就提交，或点“下一步”继续阅读。',
  demoGuideOrderbookTitle: '你的订单在订单簿上',
  demoGuideOrderbookBody: '订单簿显示挂单中的买盘和卖盘。当你下了限价单后，它会出现在这里（通常标为“你”），直到成交或你取消。',
  demoGuideOrderbookHint: '如果你还没有挂单，我会放一笔小的演示买单，方便你看效果。',
  demoGuidePostOnlyTitle: '只挂单（仅做市）',
  demoGuidePostOnlyBody: '“只挂单”表示你的限价买单只会作为 maker 挂出。如果价格会立刻与卖盘成交，订单会被拒绝并退回资金——适合你从不想吃流动性时使用。',
  demoGuidePostOnlyHint: '已勾选“只挂单”，并准备好一笔不交叉的 45¢ 买单。可试试提交，或点“下一步”继续。',
  demoGuideCancelTitle: '取消挂单',
  demoGuideCancelBody: '改主意了？未成交订单在“我的持仓”里。取消会释放买单预留的现金（或卖单锁定的份额），方便你重新使用。',
  demoGuideCancelHint: '想练习的话，点这里某一行的“取消”——我会为你保留一笔挂单买单。',
  demoGuideMarketTitle: '想更快？用市价单',
  demoGuideMarketBody: '市价单会立刻按当前订单簿成交。适合你想马上拿到份额、并能接受按现有卖价成交，而不是等待自己的限价单。',
  demoGuideMarketHint: '我已在“市价”设好 $5 买入。提交可看即时成交，或点“下一步”继续。',
  demoGuideMintTitle: '没有卖盘？铸造仍然可用',
  demoGuideMintBody: '即使没人在卖，你仍可获得份额。引擎可通过把你的买单与对侧买单撮合，用抵押金铸造“是+否”——所以卖盘为空并不总是意味着“卡住”。',
  demoGuideMintHint: '我已清空该选项的卖盘。一笔 $5 市价买单已就绪——即使卖盘为空，也能看到份额出现。',
  demoGuideSplitTitle: '成交不了？用拆分',
  demoGuideSplitBody: '拆分会立刻把抵押金变成等额的“是”和“否”份额，无需对手方。适合订单簿很薄、你想先拿到库存后再卖掉不想要的一侧。',
  demoGuideSplitHint: '我建议拆分 $10。试一下可看到“是”和“否”都增加，或点“下一步”继续。',
  demoGuideMergeTitle: '合并换回现金',
  demoGuideMergeBody: '合并是拆分的反向操作：烧掉等额的“是”和“否”份额，换回抵押金。适合你同时持有两侧、想平仓回现金时。',
  demoGuideMergeHint: '我建议每侧合并 5 份。你需要有匹配的可用“是”和“否”——不够的话先拆分。',
  demoGuideResolveTitle: '关闭并结算',
  demoGuideResolveBody: '交易结束后，市场会先关闭再结算。获胜份额每份支付 $1；失败份额结算为 $0。在演示里，“管理市场”可模拟关闭 → 选择赢家 → 结算。',
  demoGuideResolveHint: '如果面板未打开请先打开。先关闭市场，再为所选选项选择是/否并结算。',
  demoGuideDoneTitle: '你已掌握基础',
  demoGuideDoneBody: '限价控制价格、只挂单保持做市、取消释放预留资金、市价追求速度、卖盘为空时用铸造、拆分/合并管理库存，以及用管理市场完成结算。',
  demoGuideDoneHint: '随时可从“指南”按钮重播。重新进入演示模式时，演示资金会重置。',
  demoGuideWaitingForAction: '先完成高亮的操作再继续。',
  demoGuideDoThisFirst: '先做这一步',
  ganamosPolyTrade: 'Ganamos PolyTrade',
  trending: '热门',
  new: '最新',
  buyYes: '买入“是”',
  breaking: '突发',
  noBreakingMarketsRightNow: '当前没有突发市场。',
  backToMarkets: '返回市场',
  markets: '市场',
  openFullMarket: '打开完整市场',
  tradeMarket: '交易市场',
  previousMarket: '上一个市场',
  nextMarket: '下一个市场',
  breakingMarkets: '突发市场',
  showBreakingMarket: '显示第 {{index}} 个突发市场',
  featuredMarkets: '精选市场',
  topMovers: '涨跌榜',
  viewAll: '查看全部',
  liveTrades: '实时交易',
  live: '实时',
  featuredMarket: '精选市场',
  untitledMarket: '未命名市场',
  traders: '交易者',
  endsIn: '结束于',
  tradeNow: '立即交易',
  showFeaturedMarket: '显示第 {{index}} 个精选市场',
  openNewsHeadline: '打开新闻：{{headline}}',
  openNewsStatus: '打开新闻：{{statusText}}',
  news: '新闻',
  minimizeNews: '收起新闻',
  expandNews: '展开新闻',
  closeNews: '关闭新闻',
  liveWire: '实时快讯',
  categoryNews: '{{category}} 新闻',
  categoryDesk: '{{category}} 编辑台',
  topHeadlinesAndRelatedCoverage: '此市场分类的头条新闻和相关报道',
  topHeadlinesCount: '头条 {{count}} 条',
  moreRelevantNews: '更多相关新闻',
  noNewsStoriesForThisCategoryYet: '该分类暂无新闻。',
  pullingHeadlinesFromTheWire: '正在拉取快讯头条…',
  scanningWire: '正在扫描快讯…',
  categoryWaitingForStories: '{{category}} · 等待新闻',
  categoryStoriesCount: '{{category}} · {{count}} 条新闻',
  searchMarkets: '搜索市场...',
  searchPortfolioActivity: '搜索投资组合活动',
  refreshPortfolioActivity: '刷新投资组合活动',
  portfolioSections: '投资组合分区',
  noPositionsFound: '未找到持仓',
  yourOwnedPositionsWillAppearHere: '你持有的仓位会显示在这里。',
  noOrdersFound: '未找到订单',
  marketOrdersWillAppearInThisSection: '市价单会显示在此区域。',
  limitOrdersWillAppearInThisSection: '限价单会显示在此区域。',
  noActivityYet: '暂时没有活动',
  completedTradesAndSettlementsWillBeListedHere: '已完成的交易和结算会列在这里。',
  cancelThisOrder: '取消此订单？',
  cancelThisOrderDescription: '这将从订单簿中移除你的未成交限价单。你可以随时重新下单。',
  keepOrder: '保留订单',
  cancelOrder: '取消订单',
  yourTradingDesk: '你的交易面板',
  stateFilters: '状态筛选',
  tablePagination: '表格分页',
  pagination: '分页',
  previousPage: '上一页',
  nextPage: '下一页',
  noDataAvailable: '没有可用数据',
  dataWillAppearHere: '数据会显示在这里',
  thumbnail: '缩略图',
  actions: '操作',
  rowThumbnail: '行缩略图',
  yourPerformance: '你的表现',
  walletBalance: '钱包余额',
  totalProfitIncludingTakerFee: '总利润（含吃单手续费）',
  totalProfit: '总利润',
  hideTakerFee: '隐藏吃单手续费',
  showTakerFee: '显示吃单手续费',
  profitOverTime: '利润随时间变化',
  noChartDataAvailable: '暂无图表数据',
  profitHistoryWillAppearAsTradesArePlaced: '随着交易发生，利润历史会显示在这里。',
  profitChartTimeRange: '利润图时间范围',
  userActivity: '用户活动',
  userActivityTitle: '用户活动',
  userActivityTabs: '用户活动标签',
  refreshUserActivity: '刷新用户活动',
  addYourComment: '添加你的评论',
  shareYourThoughtsAboutThisMarket: '分享你对这个市场的看法...',
  anonymous: '匿名',
  hideReplies: '隐藏回复',
  showReplies: '显示回复',
  writeAReply: '写一条回复...',
  loadingEllipsis: '加载中...',
  recentMarketBuysAndSellsWillAppearHere: '最近的市场买卖会显示在这里。',
  topHolders: '最大持有者',
  topPositions: '最大持仓',
  noTopPositionsFound: '未找到最大持仓',
  topPositionsWillAppearHereWithHighestRealizedPnl: '这里将显示已实现盈亏最高的持仓',
  yesHolders: '“是”持有者',
  noHolders: '“否”持有者',
  noTopHoldersFoundForYesOutcome: '未找到“是”结果的最大持有者',
  topHoldersWillAppearHereForYesOutcome: '“是”结果的最大持有者会显示在这里',
  noTopHoldersFoundForNoOutcome: '未找到“否”结果的最大持有者',
  topHoldersWillAppearHereForNoOutcome: '“否”结果的最大持有者会显示在这里',
  optionDetailsTabs: '选项详情标签',
  orderbookOutcome: '订单簿结果',
  orderbook: '订单簿',
  graph: '图表',
  myPosition: '我的持仓',
  yesBook: '“是”订单簿',
  noBook: '“否”订单簿',
  spread: '价差',
  you: '你',
  noAsks: '暂无卖单',
  noBids: '暂无买单',
  loadingPosition: '正在加载持仓...',
  yourOrders: '你的订单',
  marketOrdersForThisOptionWillAppearHere: '此选项的市价单会显示在这里。',
  limitOrdersForThisOptionWillAppearHere: '此选项的限价单会显示在这里。',
  rulesAndMarketContext: '规则与市场背景',
  marketResolvesBasedOnListedCriteriaAndFinalOutcomeData: '市场将根据列出的标准和最终结果数据进行判定。',
  matchingEngineSettlesOpenOrdersUsingMarketResolutionRules: '撮合引擎会根据市场判定规则处理未结订单。',
  ambiguousOutcomesAreHandledByPlatformAdjudicationPolicy: '含糊结果将按平台裁定政策处理。',
  defaultPredictionMarketRules: `
  规则：
  - 本市场将根据问题中描述的结果进行判定。判定将使用公开且可靠的来源，例如官方声明、经过验证的数据提供方或信誉良好的新闻机构。
  - 如果结果在列出的结束日期之前已经明确，市场可能会提前判定。如果事件无法确定或问题变得含糊，平台可根据现有信息以最佳判断方式进行判定。
  - 所有判定均为最终结果。`,
  pleaseLogInToFavouriteQuestions: '请先登录后再收藏问题。',
  removeFromFavourites: '从收藏中移除',
  addToFavourites: '添加到收藏',
  unableToUpdateFavouriteQuestionPleaseTryAgain: '无法更新收藏问题。请再试一次。',
  marketOrderInProgress: '市价单进行中',
  noActiveMarketOrder: '没有进行中的市价单',
  marketOrderRunning: '市价单运行中',
  remainingAmount: '剩余：${{amount}}',
  remainingShares: '剩余：{{shares}} 份',
  statusState: '状态：{{state}}',
  noMarketOrderRunning: '当前没有进行中的市价单。你可以在投资组合页面的“订单”标签中查看过去的市价单。',
  deposit: '充值',
  withdraw: '提现',
  closeWalletActivityModal: '关闭钱包活动弹窗',
  enterAmountToAction: '输入{{action}}金额',
  depositSuccessful: '充值成功',
  depositFailedPleaseTryAgain: '充值失败。请再试一次。',
  withdrawalSuccessful: '提现成功',
  withdrawFailedPleaseTryAgain: '提现失败。请再试一次。',
  mergeSuccessfulBalanceCredited: '合并成功。余额已入账。',
  mergeSuccessfulCreditPending: '合并成功。入账处理中，余额将很快更新。',
  orderPlacedSuccessfully: '下单成功',
  placeOrderFailedPleaseTryAgain: '下单失败。请再试一次。',
  orderCancelledSuccessfully: '订单取消成功',
  cancelLimitOrderFailedPleaseTryAgain: '取消限价单失败。请再试一次。',
  commentAdded: '评论已添加',
  addCommentFailedPleaseTryAgain: '添加评论失败。请再试一次。',
  commentDeleted: '评论已删除',
  deleteCommentFailedPleaseTryAgain: '删除评论失败。请再试一次。',
  failedToLoadNotifications: '加载通知失败',
  commentCannotBeEmpty: '评论不能为空。',
  commentNotFound: '未找到评论。',
  demoMultiOutcomeMarket: '演示多结果市场',
  outcomeAlpha: '结果 Alpha',
  outcomeBeta: '结果 Beta',
  outcomeGamma: '结果 Gamma',
  greatMarketToLearnLimitOrders: '这是学习限价单的好市场，试着在当前价格下方挂一个买单。',
  theOrderbookUpdatesLiveOnceYouStartPlacingDemoOrders: '一旦你开始下演示订单，订单簿就会实时更新。',
  demoOutcome: '演示结果',
  demoMarketControls: '演示市场控制',
  simulateCloseAndSettlementToSeeHowTheMarketBehaves: '模拟关闭和结算，看看市场会如何表现。',
  closePanel: '关闭面板',
  closeMarket: '关闭市场',
  tradingOpen: '交易开放',
  stopsTradingClearsTheOrderbookAndClosesOpenOrders: '停止交易、清空订单簿并关闭未结订单。买单中剩余的预付金额会退回你的钱包。持仓会保持到结算为止。',
  marketClosed: '市场已关闭',
  settleMarket: '结算市场',
  ready: '就绪',
  awaitingClose: '等待关闭',
  pickTheWinningOutcomeDescription: '选择获胜结果。获胜份额每份支付 $1，持仓会被清算，选项会以最终结果显示为已结算。',
  winningOutcome: '获胜结果',
  settlementOutcome: '结算结果',
  closeManageMarketPanel: '关闭市场管理面板',
  manageMarket: '管理市场',
  manageDemoMarket: '管理演示市场',
  noChartDataYet: '暂无图表数据',
  priceHistoryWillAppearHereAsTradesHappen: '随着交易发生，价格历史会显示在这里。',
  chartTimeRange: '图表时间范围',
  allMarkets: '全部市场',
  backToCollateral: '换回抵押金 · {{marketTitle}}',
  demo: '演示',
  depositing: '充值中...',
  equalYesAndNoShares: '等额“是”和“否”份额 · {{marketTitle}}',
  estValue: '预计 {{value}}',
  favouriteQuestions: '收藏的问题',
  favourites: '收藏',
  feePerShareFormula: '每份费用（¢）= 价格 × (100 − 价格) × {{coefficient}} / 10,000',
  limitBuy: '限价买入',
  limitSell: '限价卖出',
  marketBuyOn: '在 {{marketTitle}} 市价买入',
  marketSellOn: '在 {{marketTitle}} 市价卖出',
  marketResolutionPayoutReceived: '已收到市场结算付款。新余额：{{currency}} {{formattedBalance}}',
  marketsPagination: '市场分页',
  noFavouriteQuestionsYet: '暂无收藏的问题。',
  noTitle: '无标题',
  optionNumber: '选项 {{number}}',
  postOnlyLimitBuy: '仅挂单限价买入',
  system: '系统',
  unknownOrderType: '未知订单类型：{{orderType}}',
  withdrawing: '提现中...',
  yourBalanceWasCredited: '你的余额已入账。新余额：{{currency}} {{formattedBalance}}',
  yourBalanceWasDebited: '你的余额已扣减。新余额：{{currency}} {{formattedBalance}}',
  thisMarket: '此市场',
  yourPositionText: '你的持仓',
  amountYesAndNo: '{{amount}} 是 + {{amount}} 否',
  daysAgo: '{{days}} 天前',
  hoursAgo: '{{hours}} 小时前',
  minutesAgo: '{{minutes}} 分钟前',
  outcomeSharesAtMarket: '按市价的 {{outcome}} 份额',
  sharesYesAndNo: '{{shares}} 是 + {{shares}} 否',
  sharesOutcomeAtPrice: '{{shares}} {{outcome}} @ {{price}}¢ · {{marketTitle}}',
  sharesOutcome: '{{shares}} 份 {{outcome}}',
  marketQuestionResolved: '市场“{{questionTitle}}”已判定。'
}

export default {
  ...en,
  ...reservedTranslationsWithUniqueKeyNames,
  ...apiSuccessMessagesTranslations,
  ...apiErrorMessagesTranslations,
  ...otherTranslationKeys,
  ...predictionMarketTranslations
}
